import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UtilsService} from '../../../../shared/utils/utils.service';
import {NgbDateItParserFormatter} from '../../../../component/date-custom/ngb-date-it-parser-formatter';
import {NgbDateParserFormatter, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import {CustomDatepickerI18n, I18n} from '../../../../component/date-custom/ng-bootstrap-datepicker-i18n';
import {TesseramentoService} from '../../tesseramento.service';
import * as _ from 'lodash';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-crea-dirigente',
  templateUrl: 'crea-tesseramento-dirigente.component.html',
  styleUrls: ['crea-tesseramento-dirigente.component.scss'],
  providers: [
    I18n,
    {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
    {provide: NgbDateParserFormatter, useClass: NgbDateItParserFormatter}
  ] // define custom NgbDatepickerI18n provider
})

export class CreaTesseramentoDirigenteComponent implements OnInit {

  regularForm: FormGroup;
  documentTypes: any[];
  chiefLegal: any;
  edit: boolean;
  executivePosition: any;
  subscriberPersonalData: any;
  public onClose: Subject<any>;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private utilsService: UtilsService,
    private tesseramentoServie: TesseramentoService
  ) {
  }

  ngOnInit() {
    this.onClose = new Subject();
    this.tesseramentoServie.getSubscriberDocuementTypes().subscribe((res) => {
      this.documentTypes = res;
      // this.regularForm = this.createCheafLegalFormGroup();
      this.regularForm = this.subscriberPersonalData;

      const cf = this.regularForm.get('cf').value;

      if (this.edit) {
        this.regularForm.get('cf').disable();
        this.regularForm.get('firstname').disable();
        this.regularForm.get('lastname').disable();
      } else {
        this.regularForm.setControl(
          'cf',
          new FormControl(cf ? cf : null, {
            validators: Validators.required,
            asyncValidators: this.checkSubscriberCfAndGetValues.bind(this),
            updateOn: 'blur'
          })
        );
        this.regularForm.disable();
        this.regularForm.get('cf').enable();
      }

      // if (!this.regularForm.get('identityDocument.type.id').value) {
      //   this.regularForm.get('identityDocument.type.id').setValue(this.documentTypes[0].id)
      //   this.regularForm.get('identityDocument.type.code').setValue(this.documentTypes[0].code)
      //   this.regularForm.get('identityDocument.type.description').setValue(this.documentTypes[0].description)
      // }

      if (this.executivePosition) {
        this.regularForm.setControl(
          'executivePosition',
          this.fb.group({
            id: this.executivePosition.id,
            code: this.executivePosition.code,
            description: this.executivePosition.description
          })
        )
      }
    })
  }

  get identityDocument(): FormGroup {
    return this.regularForm.get('identityDocument') as FormGroup;
  };

  checkSubscriberCfAndGetValues(control: AbstractControl) {

    return new Promise(
      (resolve, reject) => {
        this.utilsService.checkSubscriberCF(control.value)
          .subscribe(
            (res: any) => {
              if (!res.message) {
                this.regularForm.get('firstname').patchValue(res.firstname);
                this.regularForm.get('lastname').patchValue(res.lastname);
                if (!this.edit) {
                  this.regularForm.get('firstname').markAsTouched();
                  this.regularForm.get('firstname').enable();
                  this.regularForm.get('lastname').markAsTouched();
                  this.regularForm.get('lastname').enable();
                }
                this.regularForm.get('dateOfBirth').patchValue(res.dateOfBirth);
                this.regularForm.get('dateOfBirth').markAsTouched();
                this.regularForm.get('dateOfBirth').enable();
                this.regularForm.get('email').patchValue(res.email);
                this.regularForm.get('email').enable();
                this.regularForm.get('email').markAsTouched();
                this.regularForm.get('mobile').patchValue(res.mobile);
                this.regularForm.get('mobile').markAsTouched();
                this.regularForm.get('mobile').enable();
                this.regularForm.get('phone').patchValue(res.phone);
                this.regularForm.get('phone').markAsTouched();
                this.regularForm.get('phone').enable();
                if (res.identityDocument && res.identityDocument.type) {
                  this.regularForm.get('identityDocument.type').patchValue(res.identityDocument.type);
                }
                this.regularForm.get('identityDocument.type').markAsTouched();
                this.regularForm.get('identityDocument.type').enable();
                this.regularForm.get('identityDocument.number').patchValue(res.identityDocument ? res.identityDocument.number : null);
                this.regularForm.get('identityDocument.number').markAsTouched();
                this.regularForm.get('identityDocument.number').enable();
                this.regularForm.get('identityDocument.releasedBy').patchValue(res.identityDocument ? res.identityDocument.releasedBy : null);
                this.regularForm.get('identityDocument.releasedBy').markAsTouched();
                this.regularForm.get('identityDocument.releasedBy').enable();
                this.regularForm.get('identityDocument.releaseDate').patchValue(res.identityDocument ? NgbDateItParserFormatter.parse(res.identityDocument.releaseDate) : null);
                this.regularForm.get('identityDocument.releaseDate').markAsTouched();
                this.regularForm.get('identityDocument.releaseDate').enable();
                this.regularForm.get('identityDocument.expirationDate').patchValue(res.identityDocument ? NgbDateItParserFormatter.parse(res.identityDocument.expirationDate) : null);
                this.regularForm.get('identityDocument.expirationDate').markAsTouched();
                this.regularForm.get('identityDocument.expirationDate').enable();
                resolve(null);
              } else {
                resolve({invalid: true});
              }
            },
            err => {
              // console.log(err)
            }
          )
      }
    );
  }

  salva() {

    this.onClose.next(this.regularForm.getRawValue())
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/servizi/tesseramento/crea-tesseramento/dirigente/crea-tesseramento-dirigente.component.ts